module.exports = __webpack_public_path__ + "img/block4.5ec1bbae.svg";